import React from "react";

function FukPage(props) {
  return <div>FukPage</div>;
}

export default FukPage;
